import React from 'react';
import { createRoot } from 'react-dom/client';
import BracketEmbed from './bracket/app';
const rootElement = document.getElementById('bracket');
if(rootElement){
    const bracket_competition_id = rootElement.dataset.bracketcompetitionid
    const refer = rootElement.dataset.refer
    const inset_top = rootElement.dataset.insettop
    let int_top = parseInt(inset_top as string);

    const inset_bottom = rootElement.dataset.insetbottom
    let int_bottom = parseInt(inset_bottom as string);

    const inset_left = rootElement.dataset.insetleft
    let int_left = parseInt(inset_left as string);

    const inset_right = rootElement.dataset.insetright
    let int_right = parseInt(inset_right as string);

    if(isNaN(int_top)){ int_top = 0 }
    const root = createRoot(rootElement);
    root.render(
        <BracketEmbed 
            bracket_competition_id={bracket_competition_id}
            refer={refer}
            insets={{ top:int_top, left:int_left, right:int_right, bottom:int_bottom }}
        />
    )
}
